import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const HFAPublisherNumberToolTip = () => (
    <CustomToolTip type="?" info="If you are an HFA affiliate, you can find this number in your HFA portal." />
)

export default HFAPublisherNumberToolTip
